<template>
  <div class="page">
    <UpgradeBanner></UpgradeBanner>
    <PageHeader
      title="Bot Studio"
      description="Automate your first response and data capture or create your own bot experiences"
      :tabs="tabs"
      :buttons="buttons"
    />
    <router-view></router-view>
    <BotPreviewModal v-if="botPreviewActive" @cancel="closeBotPreviewModal" />
  </div>
</template>

<script lang="ts" setup>
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { TabItem } from '@/shared/components/pageHeader/tabItem';
import { ATTENDANT_TRIAGE_FLOWS_ENABLED, NLP_ENABLED } from '@/store/app/featureTypes';
import BotPreviewModal from '@/features/bots/components/botTestTool/BotPreviewModal.vue';
import appInsights from '@/shared/services/appInsights';
import UpgradeBanner from '@/features/bots/components/UpgradeBanner.vue';
import { HeaderButton } from '@/shared/components/pageHeader/headerButton';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';

const store = useStore();
const isWorkspaceFeatureEnabled = (feature: string) => computed(() => store.getters.isWorkspaceFeatureEnabled(feature));
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const botPreviewActive = ref(false);

const tabs = computed<TabItem[]>(() => {
  const tabs = [];

  if (isWorkspaceFeatureEnabled(ATTENDANT_TRIAGE_FLOWS_ENABLED)) {
    tabs.push({ name: 'Tasks', route: 'bots-tasks' });
  }

  tabs.push({ name: 'Flows', route: 'bots-flows' });

  if (isWorkspaceFeatureEnabled(NLP_ENABLED)) {
    tabs.push({ name: 'FAQs', route: 'bots-answers' });
    tabs.push({ name: 'Intents', route: 'bots-intents' });
    tabs.push({ name: 'Active Learning', route: 'bots-active-learning' });
  }

  return tabs;
});

const buttons: HeaderButton[] = [
  {
    clickHandler: () => openBotPreviewModal(),
    content: 'Preview your Bot',
    variant: 'secondary',
  },
];

function openBotPreviewModal() {
  botPreviewActive.value = true;
  appInsights.trackEvent({ name: 'Preview your Bot clicked' }, { workspaceId: currentWorkspace.value.id });
}

function closeBotPreviewModal() {
  botPreviewActive.value = false;
}
</script>
